import { Component, OnInit, ComponentFactoryResolver, Injector, Input, ViewChild, ElementRef, HostBinding, AfterViewInit, NgZone, TemplateRef, EventEmitter, Output, ChangeDetectorRef, Optional, LOCALE_ID, Inject } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ProcessDesignerUIState } from '../../../../app/process-designer.uistate';
import { ExpressionService, InjectedType } from '@gsp-svc/expression';
import { SessionService } from '@ecp-caf/caf-common';
import { BsModalService } from '@farris/ui-modal';
import { CommonComponentUiRTService, SelectorResult } from '@gsp-cmp/ccmp-ui';
import { SelectMetadataRTComponent, Metadata4RefDto, MetadataDto } from '@gsp-lcm/metadatart-selector';
import { GspComponent } from '@gsp-cmp/common-component';
import { DataColumn, DatagridComponent } from '@farris/ui-datagrid';
import { of, forkJoin, Observable } from 'rxjs';
import { RowEditParam } from '@farris/ui-datagrid/lib/types';
import { EditorTypes } from '@farris/ui-datagrid-editors';
import { LookupGridComponent, LookupGridResult, ServerSideToken } from '@farris/ui-lookup';
import { WebServiceParameter, ParameterFetchValueMode, HelpFetchValueSetting } from '@gsp-cmp/wscmp-models';
import { ComponentEditLookUpService } from './component-edit-lookup.service';
import { ComponentEditService } from './component-edit.service';
import { ComponentEntity, ActualParameter } from './component.entity';
import { ProcessDeUtil } from '../../../../domain/process-de-util';
import { MessagerService } from '@farris/ui-messager';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../../../i18n/assets/lang.resource';

@Component({
  selector: 'lib-component-edit',
  templateUrl: './component-edit.component.html',
  styleUrls: ['./component-edit.component.scss'],
  providers: [
    ComponentEditService,
    { provide: ServerSideToken, useClass: ComponentEditLookUpService },
     WfLocalePipe,
  ]
})
export class ComponentEditComponent implements OnInit, AfterViewInit {
  @HostBinding('class')
  cls = 'farris-main-area flex-column';

  @ViewChild(DatagridComponent) grid: DatagridComponent;
  @ViewChild(LookupGridComponent) lookup: LookupGridComponent;

  @ViewChild('footer') footer: TemplateRef<any>;

  @Output() closeEmitter = new EventEmitter<any>();
  @Output() submitEmitter = new EventEmitter<any>();

  @ViewChild('inputGroup') inputGroup: ElementRef;
  showClearButton = false;

  private _component: any = new ComponentEntity();
  @Input()
  set component(cmp: ComponentEntity) {
    if (cmp && cmp.MethodCode) {
      this.service.getHelpMetaData(cmp.MetadataId, '').subscribe(re => {
        const c = JSON.parse(re.content);
        const operation = c.operations.find(o => o.code === cmp.MethodCode);
        if (operation) {
          cmp.ActualParameters = cmp.ActualParameters.map(a => {
            const p = operation.parameters.find(i => i.code === a.Name);
            if (p) {
              return {
                ...a,
                fetchValueMode: p.fetchValueMode,
                fetchValueSetting: p.fetchValueSetting
              };
            } else {
              throw new Error(this.localePipe.transform("component.variableSetting.inconsistentParameters"));
            }
          });
          this._component = cmp;
        } else {
          throw new Error(this.localePipe.transform("component.variableSetting.methodNotExist"));
        }
      });
    } else {
      this._component = new ComponentEntity();
    }
  }
  get component() {
    return this._component;
  }

  curParameter: ActualParameter;
  columns = [
    { field: 'Name', width: 100, title: this.localePipe.transform("component.variableSetting.parameterName") },
    {
      field: 'Value', width: 100, title: this.localePipe.transform("component.variableSetting.parameterValue"),
      editor: {
        type: 'input-group',
        options: {
          groupText: '<i class="f-icon f-icon-lookup"></i>',
          editable: false,
          clickHandle: (e) => {
            e.formControl.setValue(e.instance.value ? e.instance.value : '');
            this.showExprHelp(e);
          },
          clear: (e) => {
            console.log('clear', e);
          }
        }
      }
    }
  ];

  helpFields: { idField: string, valueField: string; textField: string } = {
    idField: '',
    valueField: '',
    textField: ''
  };
  dataUri = '/api/runtime/wf/v1.0/dtProcDefs/getHelpData';
  helpId;
  su: string;
  helpCols = [];
  displayType = 'List';
  title = '';
  value: any;

  cell: any;
  constructor(
    private formBuilder: FormBuilder,
    private designerState: ProcessDesignerUIState,
    private expr: ExpressionService,
    private resolver: ComponentFactoryResolver,
    private injector: Injector,
    private sessionSrc: SessionService,
    private modalService: BsModalService,
    private componentService: CommonComponentUiRTService,
    private ngZone: NgZone,
    private service: ComponentEditService,
    private util: ProcessDeUtil,
    private message: MessagerService,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe,
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
  }

  ngOnInit() {
  }
  ngAfterViewInit(): void {
    this.ngZone.runOutsideAngular(() => {
      this.inputGroup.nativeElement.addEventListener(
        'mouseenter',
        this.onMouseEnter.bind(this)
      );
      this.inputGroup.nativeElement.addEventListener(
        'mouseleave',
        this.onMouseLeave.bind(this)
      );
    });
  }

  onMouseEnter(event) {
    this.showClearButton = true;
    if (this.showClearButton) {
      this.toggleClearIcon(event, true);
    }
  }
  onMouseLeave(event) {
    this.showClearButton = false;
    this.toggleClearIcon(event, false);
  }

  private toggleClearIcon(event: any, isShow = false) {
    const str = isShow ? '' : 'none';
    const clearIcon = event.target.querySelector('.input-group-clear');
    if (clearIcon) {
      clearIcon.style.display = str;
    }
  }


  clickOK() {
    this.grid.endCellEdit();
    if (this.validator()) {
      this.submitEmitter.emit(this.component);
    } else {
      this.message.info(this.localePipe.transform("component.variableSetting.methodnotSelected"));
    }
  }

  clickCancel() {
    this.closeEmitter.emit();
  }

  private validator() {
    if (!this.component.MethodCode || !this.component.MetadataId) {
      return false;
    }
    return true;
  }
  beforeEdit = (param: RowEditParam) => {
    const rowData = param.rowData as any;
    switch (rowData.fetchValueMode) {
      case ParameterFetchValueMode.express:
        param.column.editor = {
          type: 'input-group',
          options: {
            groupText: '<i class="f-icon f-icon-lookup"></i>',
            editable: false,
            clickHandle: (e) => {
              e.formControl.setValue(e.instance.value ? e.instance.value : '');
              this.showExprHelp(e);
            },
            clear: (e) => {
              console.log('clear', e);
            }
          }
        };
        break;
      case ParameterFetchValueMode.none:
        param.column.editor = {
          type: 'input-group',
          options: {
            groupText: '<i class="f-icon f-icon-lookup"></i>',
            editable: false,
            clickHandle: (e) => {
              e.formControl.setValue(e.instance.value ? e.instance.value : '');
              this.showExprHelp(e);
            },
            clear: (e) => {
              console.log('clear', e);
            }
          }
        };
        break;
      case ParameterFetchValueMode.const:
        param.column.editor = { type: EditorTypes.TEXTBOX, options: {} };
        break;
      case ParameterFetchValueMode.enum:
        param.column.editor = { type: EditorTypes.TEXTBOX, options: {} };
        break;
      case ParameterFetchValueMode.help:
        param.column.editor = {
          type: 'input-group',
          options: {
            groupText: '<i class="f-icon f-icon-lookup"></i>',
            editable: false,
            clickHandle: (e) => {
              this.cell = e;
              this.helpId = (rowData.fetchValueSetting as HelpFetchValueSetting).helpId;
              this.su = (rowData.fetchValueSetting as HelpFetchValueSetting).serviceUnit;
              this.getHelpInfo().subscribe(re => {
                console.log(re);
                const meta = re;
                const help = JSON.parse(meta.content) as any;
                this.helpCols = help.dataSource.columns;
                this.displayType = help.displayType;
                this.helpFields = {
                  idField: help.idField,
                  valueField: help.valueField,
                  textField: help.textField
                };
                this.lookup.onClear();
                this.lookup.showDialog();
              }, err => {
                  this.message.error(this.localePipe.transform("component.variableSetting.metadataNotExist"));
              });
            },
            clear: (e) => {
              console.log('clear', e);
            }
          }
        };
        break;
    }
    return of(true);
  }
  afterEdit = (rowIndex: number, rowData: any, column?: DataColumn) => {
    return of(true);
  }

  clear() {
    this.component = new ComponentEntity();
  }
  selectComponent() {
    const compFactory = this.resolver.resolveComponentFactory(SelectMetadataRTComponent);
    const compRef = compFactory.create(this.injector);
    compRef.instance.typeList = 'WebServiceComponent'; // 目前只能根据元数据类型过滤，后续添加标签过滤
    compRef.instance.selectedMetadata.subscribe(($event: Metadata4RefDto) => {
      try {
        const meta: MetadataDto = $event.metadata;
        this.openComponentSelectorNew(meta.id, this.sessionSrc.getUserSessionId());
      } catch {
        console.log('$event', $event);
        throw new Error(this.localePipe.transform("component.variableSetting.errorObtainComponent") + $event);
      }
    });

    const modalConfig = {
      title: this.localePipe.transform("component.variableSetting.componentSelection"),
      width: 980,
      height: 548,
      showButtons: false
    };
    const dialog = this.modalService.show(compRef, modalConfig);
    compRef.instance.closeModalEmitter.subscribe($event => dialog.close());
  }
  private openComponentSelectorNew(metadataId: string, sessionId: string) {
    this.componentService.openSelector(metadataId, sessionId).subscribe(
      (selectorResult: SelectorResult) => {
        selectorResult.confirmEvent.subscribe(
          (result: GspComponent) => {
            if (result) {
              this.component.Name = result.name;
              this.component.MetadataId = result.id;
              this.component.MethodCode = result.operations[0].code;
              // this.component.methodName = result.operations[0].name;
              this.component.ActualParameters = [];

              if (result.operations[0].parameters && result.operations[0].parameters.length > 0) {
                this.component.ActualParameters = result.operations[0].parameters
                  .map((p: WebServiceParameter) => (
                    {
                      Name: p.code, Value: '', Tag: p.fetchValueMode.indexOf('express,none') > -1 ? 'expression' : 'constant',
                      fetchValueMode: p.fetchValueMode,
                      fetchValueSetting: p.fetchValueSetting
                    }));
              }
            }
          });
      });
  }
  showExprHelp(e: any) {
    // this.expr.clearContext();
    if (this.designerState.schemas.length > 0) {
      for (const schema of this.designerState.schemas) {
        this.expr.addSchema('Schema', schema);
      }
      if (this.designerState.schemas[0].entityTypes && this.designerState.schemas[0].entityTypes.length > 0) {
        const entityType = this.designerState.schemas[0].entityTypes[0];
        this.expr.addInjectedEntity(entityType.name, 'Schema',
          entityType.name, InjectedType.EntityType);
      }
    }
    let context = new Array();
    context = this.designerState.addContext(context);
    if (this.designerState.subActivityContext.length > 0) {
      for (const variable of this.designerState.subActivityContext) {
        if (!context.some(c => c.key === variable.key)) {
          context.push(variable);
        }
        // this.expr.addContext(variable);
      }
    }
    if (context.length > 0) {
      for (const v of context) {
        this.expr.addContext(v);
      }
    }
    this.expr.addExpressionText(e.instance.value);
    this.expr.buildExpression().then((d: string) => {
        e.formControl.setValue(d);
        e.instance.cd.detectChanges();
        //点击确定后，去除表达式里面的新增的上下文变量
        if(context.length > 0) {
          this.expr.exprEntity.contextEntities = this.expr.exprEntity.contextEntities.filter(x => !context.some(y => y.key === x.key));
        }
    });
  }

  private getHelpInfo(): Observable<any> {
    return this.service.getHelpMetaData(this.helpId, this.su);
  }

  dictPicking = () => {
    return of({
      showDialog: true, data: {
        helpId: this.helpId
      }
    });
  }
  dictPicked = (rowData) => {
    if (this.cell) {
      console.log(rowData);
      this.cell.formControl.setValue(this.util.getValue(rowData, this.helpFields.valueField));
      this.cell.instance.cd.detectChanges();
      return of(true);
    }
  }
}
